import { initializeApp, FirebaseApp } from "firebase/app";
import {
  getAuth,
  Auth,
  setPersistence,
  browserLocalPersistence,
} from "firebase/auth";
import {
  initializeFirestore,
  memoryLocalCache,
  Firestore,
} from "firebase/firestore";
import { getStorage, FirebaseStorage } from "firebase/storage";
import { getAnalytics, Analytics, isSupported } from "firebase/analytics";

// Firebase configuration for shmuelweb-475f1
const firebaseConfig = {
  apiKey: "AIzaSyCRIJijtltTHwEKN8QlwCjOlfBkqG6a3l0",
  authDomain: "sullabread.co.il",
  projectId: "shmuelweb-475f1",
  storageBucket: "shmuelweb-475f1.firebasestorage.app",
  messagingSenderId: "388005414814",
  appId: "1:388005414814:web:28ac91676ca51d961c788f",
  measurementId: "G-Q7K0NVCC2G",
};

// Firebase is properly configured
const hasValidConfig = true;

// Initialize Firebase
let app: FirebaseApp | null = null;
let auth: Auth | null = null;
let db: Firestore | null = null;
let storage: FirebaseStorage | null = null;
let analytics: Analytics | null = null;

// Function to check if the app is online
const isOnline = () => {
  return navigator.onLine;
};

// Function to initialize analytics safely
const initializeAnalyticsSafely = async (app: FirebaseApp) => {
  try {
    // Check if analytics is supported and app is online
    if (isOnline() && (await isSupported())) {
      analytics = getAnalytics(app);
          } else {
          }
  } catch (error) {
        analytics = null;
  }
};

if (hasValidConfig) {
  try {
    app = initializeApp(firebaseConfig);
    auth = getAuth(app);

    // הגדרת persistence לשמירת מצב ההתחברות
    setPersistence(auth, browserLocalPersistence).catch((error) => {
          });

    // In-memory cache (NOT IndexedDB). The persistent IndexedDB cache
    // (persistentLocalCache/persistentMultipleTabManager) gets partitioned and
    // locked by Safari when the app loads inside/after the cross-origin Tranzila
    // payment iframe, which hangs EVERY Firestore read for the rest of the
    // session (workshops, gallery, settings, contact all fail to load after a
    // payment). The memory cache avoids IndexedDB entirely and works reliably in
    // all browsers; we only lose a minor repeat-visit cold-start optimization.
    db = initializeFirestore(app, {
      localCache: memoryLocalCache(),
      // Safari fix (firebase-js-sdk#9789): Safari's streaming Fetch transport
      // blocks the Firestore Listen/Write channel ("Fetch API cannot load ...
      // due to access control checks"), hanging reads/writes. Forcing long
      // polling and disabling fetch streams uses the reliable XHR-based
      // WebChannel transport (Chrome/mobile are unaffected).
      experimentalForceLongPolling: true,
      useFetchStreams: false,
    } as Parameters<typeof initializeFirestore>[1]);
    storage = getStorage(app);

    // Initialize analytics safely
    initializeAnalyticsSafely(app);
  } catch (error) {
      }
} else {
  }

// Listen for online/offline events to handle analytics initialization
if (typeof window !== "undefined") {
  window.addEventListener("online", () => {
    if (app && !analytics) {
            initializeAnalyticsSafely(app);
    }
  });

  window.addEventListener("offline", () => {
      });
}

export { auth, db, storage, analytics };
export default app;
